// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_MqacI","navList":"index_navList_s0xrh","navItem":"index_navItem_cWRac","navText":"index_navText_pZ-32","navLink":"index_navLink_Q7Cew","active":"index_active_17CPF"};